var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 361,
    viewBox: "0 0 43.391666 95.514586",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\ng#black > circle{\n  opacity:1;\n  vector-effect:none;\n  fill:#000000;\n  fill-opacity:1;\n  stroke:none;\n  stroke-width:0.52916664;\n  stroke-linecap:butt;\n  stroke-linejoin:miter;\n  stroke-miterlimit:4;\n  stroke-dasharray:none;\n  stroke-dashoffset:0;\n  stroke-opacity:1     \n}\ng#yellow > circle{\n  style=\"display:inline;\n  opacity:1;\n  vector-effect:none;\n  fill:#fcee01;\n  fill-opacity:1;\n  stroke:none;\n  stroke-width:0.52916664;\n  stroke-linecap:butt;\n  stroke-linejoin:miter;\n  stroke-miterlimit:4;\n  stroke-dasharray:none;\n  stroke-dashoffset:0;\n  stroke-opacity:1\" \n}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "black",
    style: {
      display: "inline"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 2.1166666
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 2.1166666
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 4.2333331
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 4.2333331
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 4.2333331
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 6.3499994
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 6.3499994
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 6.3499994
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 6.3499994
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 6.3499994
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 6.3499994
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 6.3499994
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 6.3499994
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 6.3499994
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 6.3499994
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 6.3499994
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 6.3499994
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 8.4666662
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 8.4666662
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 8.4666662
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 8.4666662
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 8.4666662
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 8.4666662
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 8.4666662
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 8.4666662
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 8.4666662
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 8.4666662
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 8.4666662
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 8.4666662
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 8.4666662
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 8.4666662
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 8.4666662
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 8.4666662
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 8.4666662
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 8.4666662
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 8.4666662
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 90.222916,
    cx: 8.4666662
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 10.583333
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 10.583333
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 10.583333
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 10.583333
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 10.583333
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 10.583333
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 10.583333
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 10.583333
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 10.583333
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 10.583333
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 10.583333
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 10.583333
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 10.583333
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 10.583333
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 10.583333
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 10.583333
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 10.583333
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 10.583333
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 10.583333
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 10.583333
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 10.583333
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 10.583333
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 10.583333
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 10.583333
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 10.583333
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 90.222916,
    cx: 10.583333
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 92.339577,
    cx: 10.583333
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 12.7
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 12.7
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 12.7
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 12.7
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 12.7
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 12.7
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 12.7
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 12.7
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 12.7
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 12.7
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 12.7
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 12.7
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 12.7
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 12.7
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 12.7
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 12.7
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 12.7
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 12.7
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 12.7
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 12.7
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 12.7
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 12.7
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 12.7
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 14.816666
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 14.816666
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 14.816666
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 14.816666
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 14.816666
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 14.816666
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 14.816666
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 14.816666
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 14.816666
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 14.816666
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 14.816666
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 14.816666
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 14.816666
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 14.816666
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 14.816666
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 14.816666
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 14.816666
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 14.816666
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 14.816666
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 14.816666
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 14.816666
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 14.816666
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 14.816666
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 14.816666
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 14.816666
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 14.816666
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 16.933332
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 16.933332
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 16.933332
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 16.933332
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 16.933332
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 16.933332
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 16.933332
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 16.933332
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 16.933332
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 16.933332
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 16.933332
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 16.933332
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 16.933332
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 16.933332
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 16.933332
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 16.933332
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 16.933332
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 16.933332
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 16.933332
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 16.933332
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 16.933332
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 16.933332
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 16.933332
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 16.933332
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 16.933332
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 16.933332
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 19.049999
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 19.049999
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 19.049999
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 19.049999
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 19.049999
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 19.049999
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 19.049999
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 19.049999
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 19.049999
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 19.049999
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 19.049999
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 19.049999
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 19.049999
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 19.049999
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 19.049999
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 19.049999
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 19.049999
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 19.049999
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 19.049999
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 19.049999
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 19.049999
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 19.049999
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 19.049999
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 19.049999
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 19.049999
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 19.049999
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 19.049999
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 19.049999
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 21.166666
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 21.166666
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 21.166666
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 21.166666
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 21.166666
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 21.166666
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 21.166666
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 21.166666
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 21.166666
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 21.166666
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 21.166666
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 21.166666
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 21.166666
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 21.166666
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 21.166666
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 21.166666
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 21.166666
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 21.166666
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 21.166666
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 21.166666
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 21.166666
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 21.166666
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 21.166666
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 21.166666
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 21.166666
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 21.166666
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 21.166666
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 21.166666
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 23.283333
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 23.283333
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 23.283333
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 23.283333
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 23.283333
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 23.283333
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 23.283333
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 23.283333
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 23.283333
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 23.283333
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 23.283333
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 23.283333
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 23.283333
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 23.283333
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 23.283333
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 23.283333
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 23.283333
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 23.283333
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 50.006248,
    cx: 23.283333
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 54.239582,
    cx: 23.283333
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 23.283333
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 23.283333
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 23.283333
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 23.283333
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 23.283333
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 23.283333
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 23.283333
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 25.399998
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 25.399998
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 25.399998
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 25.399998
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 25.399998
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 25.399998
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 25.399998
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 25.399998
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 25.399998
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 25.399998
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 25.399998
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 25.399998
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 25.399998
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 25.399998
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 25.399998
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 25.399998
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 43.656246,
    cx: 25.399998
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 45.772915,
    cx: 25.399998
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 25.399998
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 25.399998
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 25.399998
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 25.399998
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 25.399998
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 25.399998
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 5.5562496,
    cx: 27.516666
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 27.516666
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 27.516666
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 27.516666
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 27.516666
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 27.516666
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 27.516666
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 27.516666
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 27.516666
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 27.516666
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 27.516666
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 27.516666
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 27.516666
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 27.516666
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 27.516666
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 27.516666
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 27.516666
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 27.516666
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 62.706249,
    cx: 27.516666
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 27.516666
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 79.63958,
    cx: 27.516666
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 81.756248,
    cx: 27.516666
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 29.633331
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 29.633331
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 29.633331
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 29.633331
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 29.633331
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 29.633331
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 29.633331
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 29.633331
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 29.633331
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 29.633331
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 29.633331
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 29.633331
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 29.633331
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 29.633331
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 29.633331
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 1.3229166,
    cx: 31.749998
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 3.4395833,
    cx: 31.749998
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 5.5562496,
    cx: 31.749998
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 31.749998
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 31.749998
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 31.749998
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 31.749998
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 31.749998
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 31.749998
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 31.749998
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 31.749998
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 31.749998
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 31.749998
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 31.749998
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 31.749998
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 31.749998
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 3.4395833,
    cx: 33.866665
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 5.5562496,
    cx: 33.866665
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 33.866665
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 33.866665
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 33.866665
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 33.866665
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 33.866665
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 33.866665
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 33.866665
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 33.866665
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 33.866665
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 33.866665
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 33.866665
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 33.866665
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 33.866665
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 33.866665
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 5.5562496,
    cx: 35.98333
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 35.98333
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 35.98333
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 35.98333
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 35.98333
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 35.98333
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 35.98333
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 35.98333
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 35.98333
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 26.722916,
    cx: 35.98333
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 30.956249,
    cx: 35.98333
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 7.6729164,
    cx: 38.099998
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 38.099998
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 38.099998
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 38.099998
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 38.099998
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 38.099998
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 38.099998
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 38.099998
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 9.7895832,
    cx: 40.216663
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 40.216663
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 14.022916,
    cx: 40.216663
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 16.139582,
    cx: 40.216663
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 40.216663
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 20.372915,
    cx: 40.216663
  }))), /*#__PURE__*/React.createElement("g", {
    id: "yellow",
    style: {
      display: "inline"
    }
  }, _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 2.1166666
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 4.2333331
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 6.3499994
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 92.339577,
    cx: 6.3499994
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 8.4666662
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 8.4666662
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 8.4666662
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 8.4666662
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 8.4666662
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 92.339577,
    cx: 8.4666662
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 10.583333
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 60.589581,
    cx: 12.7
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 12.7
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 83.87291,
    cx: 12.7
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 14.816666
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 58.472912,
    cx: 14.816666
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 85.989578,
    cx: 14.816666
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 16.933332
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 69.056244,
    cx: 16.933332
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 73.289581,
    cx: 16.933332
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 75.40625,
    cx: 16.933332
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 16.933332
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 88.106247,
    cx: 16.933332
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 24.606249,
    cx: 19.049999
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 19.049999
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 56.356247,
    cx: 19.049999
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 35.189583,
    cx: 21.166666
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 47.88958,
    cx: 21.166666
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 21.166666
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 64.822914,
    cx: 21.166666
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 37.306248,
    cx: 23.283333
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 52.122913,
    cx: 23.283333
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 41.539581,
    cx: 27.516666
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 66.939583,
    cx: 27.516666
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 77.522911,
    cx: 27.516666
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 29.633331
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 29.633331
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 39.422916,
    cx: 29.633331
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 11.90625,
    cx: 31.749998
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 28.839582,
    cx: 31.749998
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 18.25625,
    cx: 35.98333
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 33.072914,
    cx: 35.98333
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 40.216663
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 22.489582,
    cx: 42.333332
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    r: 0.66145831,
    cy: 71.172913,
    cx: 4.2333331
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.785a024c26a4ace76e8a0db287156a7e.svg";
export { ForwardRef as ReactComponent };